<template>
  <label class="image-upload">
    <span class="label" :class=state>
      <input
        ref="input"
        type="file"
        :disabled="state==='saving'"
        v-on:change="dropped($event.target.files)"
        multiple
        :accept=accept
      />
      <template v-if="srcs && srcs.length && accept==='image/*'">
        <img v-for="src in srcs" :src="src" v-on:load="loaded(src)" />
      </template>
      <template v-else>
        <Icon class="placeholder" name="image" />
        <div>
          {{ 'images:upload.drop' | trans }}
          <br/>
          <small>{{ 'images:upload.or' | trans }}</small>
        </div>
      </template>
    </span>
    <p v-if="state==='saving'">{{ 'images:upload.wait' | trans }}</p>
    <a class="btn lg" v-if="state==='ready'">{{ 'images:upload.select' | trans }}</a>
  </label>
</template>

<script>
  export default {
    name: 'FileUpload',
    props: {
      value: {required: false},
      type: {default: 'image'},
      width: {},
      height: {},
    },
    data: function () {
      return {
        uploading: false,
      };
    },
    computed: {
      srcs: function () {
        if (this.value) {
          var values = [];
          for (let file of this.value) {
            values.push(window.URL.createObjectURL(file));
          }
          return values;
        } else {
          return false;
        }
      },
      accept: function () {
        switch (this.type) {
          case 'audio': return '.mp3';
          case 'video': return '.webm';
          default:      return 'image/*';
        }
      },
      state () {
        if (this.uploading) {
          return 'saving';
        }
        if (this.value) {
          return 'saving';
        }
        return 'ready';
      }
    },
    methods: {
      loaded: function (src) {
        window.URL.revokeObjectURL(src);
        this.uploading = false;
      },
      dropped: function (files) {
        if (files.length) {
          this.uploading = true;
          this.$emit('input', files);
          this.$emit('uploaded', files);
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .image-upload {
    display: block;
    p {
      line-height: 1.7em;
    }
    span.label {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      align-items: center;
      border: dashed 3px;
      position: relative;
      width: 100%;
      min-height: 200px;
      padding: 30px;
      .svg-icon {
        flex-grow: 1;
        width: 60%;
      }
      input[type="file"] {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: transparent none;
        color: transparent;
        opacity: 0;
      }
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    a.btn {
      margin-top: 20px;
      min-width: 60%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/interact/FileUpload.vue